import React from 'react'
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import ManagerFields from '../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import SummaryEmployeeContractor from '../../../../Dashboard/Contractors/SubComponents/EmployeeCreateUpdateFlows/SummaryEmployeeContractor';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { STEPS_SUPPLIER_EMPLOYEE_CREATE_NO_DETAILS } from '../../Model/Model';
import { TABS_SUPPLIER_EMPLOYEE } from '../../../../Dashboard/Company/Employees/Model/Models';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const SupplierFlowEmployeeCreateWithoutDetails = ({
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    user,
    setUser,
    emptyFields,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    resetForm,
    userInfoStatusList,
    handleValidateSteps,
    photoPicker,
    setPhotoPicker,
    extraData,
    headersList,
    extraDataEnabled,
    FormHandler
}) => {
    return (
        <StepperTabs
            steps={steps}
            activeStep={activeStep}
            isStepOptional={() => {}}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_CREATE_NO_DETAILS.MANAGER_DETAILS} activeStep={activeStep} normalHeight>
                <>
                    <ManagerFields
                        title={'user_data'}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePasswordChange={handlePasswordChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        handleClearAll={resetForm}
                        statusList={userInfoStatusList}
                    />
   <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px'>
                    <ButtonNextStep
                        text='next'
                       id="btn_sfecwd_next_photo_profile"
                        click={() => {
                            if (handleValidateSteps(TABS_SUPPLIER_EMPLOYEE.DETAILS.INDEX)) {
                                setActiveStep((prev) => prev + 1);
                            }
                        }}
                    /></div>
                </>
            </StepTab>
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_CREATE_NO_DETAILS.ADD_PHOTO} activeStep={activeStep} normalHeight>
                <>
                    <CustomPhotoPicker
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera
                        validateFace
                        showPreview
                         classWith={'content-center-w-400px mt-4'}
                        id="fp_sfecwd_create_photo_profile"
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                    />

                   <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep text='back'  id="btn_sfecwd_back_manage_fields" click={() => setActiveStep((prev) => prev - 1)} />
                        <ButtonNextStep text='next'id="btn_sfecwd_next_summary" click={() => setActiveStep((prev) => prev + 1)} />
                    </div>
                </>
            </StepTab>
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_CREATE_NO_DETAILS.SUMMARY} activeStep={activeStep} normalHeight>
                <>
                    <SummaryEmployeeContractor
                        user={user}
                        photoPicker={photoPicker}
                        extraDataEnabled={extraDataEnabled}
                        headersList={headersList}
                        extraData={extraData}
                    />

                   <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                        <ButtonPrevStep text='back'  id="btn_sfecwd_photo_profile" click={() => setActiveStep((prev) => prev - 1)} />
                        <ButtonNextStep text='create' id="btn_sfecwd_create" click={FormHandler} />
                    </div>
                </>
            </StepTab>
        </StepperTabs>
    );
};

export default SupplierFlowEmployeeCreateWithoutDetails